export { default as ComparativoFlujoCajaReport } from './Report'
